import { CHART_SCAN_ACTIVATION_MS } from "@lattice/design-tokens";

/** Matches VICTORY_CHART_PRESS_CONFIG so every chart scrubs the same way. */
export const SVG_CHART_SCRUB_LONG_PRESS_MS = CHART_SCAN_ACTIVATION_MS;

export type T_SvgChartScrubGeometry = {
  /** Number of horizontal data slots in the plot. */
  slotCount: number;
  /** SVG viewBox width the touch x must be projected into. */
  viewboxWidth: number;
  /** ViewBox x where the last slot ends. */
  xEnd: number;
  /** ViewBox x where the first slot starts. */
  xStart: number;
};

/**
 * Map a touch x (in layout pixels) to the nearest slot index of an SVG chart
 * rendered with `preserveAspectRatio="none"` at 100% width.
 */
export function svgChartScrubIndexForX(
  x: number,
  plotWidth: number,
  geometry: T_SvgChartScrubGeometry,
): number | null {
  if (plotWidth <= 0 || geometry.slotCount <= 0) return null;

  const viewX = (x / plotWidth) * geometry.viewboxWidth;
  const slotWidth = (geometry.xEnd - geometry.xStart) / geometry.slotCount;
  if (slotWidth <= 0) return null;

  const index = Math.floor((viewX - geometry.xStart) / slotWidth);
  return Math.min(geometry.slotCount - 1, Math.max(0, index));
}
